/** @format */

import { AuthLayout, HomeLayout } from "components";
import Login from "pages/auth/Login";
import { Dashboard } from "pages/dashboard";
import { ProjectForm, ProjectDetail, Projects } from "pages/projects";
import {
  DepartmentObjective,
  EmployeeObjective,
} from "pages/objectives";
import { AccountCodes } from "pages/account-codes";
import { PaymentVouchers } from "pages/payment-vouchers";
import { PaymentBankings } from "pages/payment-bankings";
import { OpeningBalance } from "pages/opening-balance";
import { Companies } from "pages/companies";
import { Customers } from "pages/customers";
import { OpeningInventories } from "pages/opening-inventories";
import { Receipts } from "pages/receipts";
import { ReceiptBankings } from "pages/receipt-bankings";
import { ReturnOrders } from "pages/return-orders";
import { Settings } from "pages/settings";
import { Tasks } from "pages/tasks";
import { Users } from "pages/users";
import { FC, ReactElement, ReactNode } from "react";
import { ROUTES } from "utils";

type TComponent = FC<{
  children: string | ReactElement | ReactElement[] | ReactNode;
}>;

export interface RouterType {
  path: string;
  component: FC;
  layout: TComponent;
}

const publicRoutes: RouterType[] = [
  {
    path: ROUTES.PUBLIC_URL.LOGIN,
    component: Login,
    layout: AuthLayout as TComponent,
  },
];

const privateRoutes: RouterType[] = [
  {
    path: ROUTES.PRIVATE_ROOT.DASHBOARD,
    component: Dashboard,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.TASKS,
    component: Tasks,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.PROJECTS,
    component: Projects,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.PROJECTS_CREATE,
    component: ProjectForm,
    layout: HomeLayout as TComponent,
  },
  {
    path: `${ROUTES.PRIVATE_ROOT.PROJECTS_DETAIL}/:id`,
    component: ProjectDetail,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.USERS,
    component: Users,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.SETTINGS,
    component: Settings,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.ACCOUNT_CODES,
    component: AccountCodes,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.PAYMENT_VOUCHERS,
    component: PaymentVouchers,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.PAYMENT_BANKINGS,
    component: PaymentBankings,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.OPENING_BALANCE,
    component: OpeningBalance,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.COMPANIES,
    component: Companies,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.RECEIPT_BANKINGS,
    component: ReceiptBankings,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.CUSTOMERS,
    component: Customers,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.OPENING_INVENTORIES,
    component: OpeningInventories,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.RECEIPTS,
    component: Receipts,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.RETURN_ORDERS,
    component: ReturnOrders,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.OBJECTIVE_CUSTOMER_OR_SUPLIES,
    component: Customers,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.OBJECTIVE_EMPLOYEE,
    component: EmployeeObjective,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.OBJECTIVE_DEPARTMENT,
    component: DepartmentObjective,
    layout: HomeLayout as TComponent,
  },
];

export { privateRoutes, publicRoutes };
